import { ReactNode } from "react";
import { Box, Fade, IconButton, Tooltip } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import styles from "./PageTitle.module.scss";
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';


interface IPageTitleProps {
  pageTitle?: ReactNode;
  pageSubtitle?: ReactNode;
  children?: ReactNode;
  returnPage?: ReactNode;
  returnLabel?: ReactNode;
}

export const PageTitle = (props: IPageTitleProps) => {
  const { pageTitle, pageSubtitle, children, returnPage, returnLabel } = props;

  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate(String(returnPage));
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1.5rem 0rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        {returnPage && returnLabel && (
          <Fade in={Boolean(returnPage && returnLabel)}>
            <Tooltip title={returnLabel}>
              <IconButton
                onClick={handleOnClick}
                sx={{ marginRight: "10px", padding: 0 }}
              >
                <NavigateBeforeIcon sx={{ fontSize: "43px" }} />
              </IconButton>
            </Tooltip>
          </Fade>
        )}
        <div>
          {pageTitle && <Typography variant="h4">{pageTitle}</Typography>}
          {pageSubtitle && <Typography variant="h5">{pageSubtitle}</Typography>}
        </div>
      </div>

      <div className={styles.actionButtons}>{children}</div>
    </Box>
  );
};
